
import React, { useState, useEffect } from 'react';
import Header from "../components/Header";
import "./gallery.css";

const MY_DOMAIN = "https://oculuseyehospitalassam.com"; 
const LIST_ENDPOINT = `${MY_DOMAIN}/list_images.php`;

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

   useEffect(() => {
    setIsLoading(true);
    fetch(LIST_ENDPOINT)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch image list");
        return res.json();
      })
      .then((data) => {
        const loadedImages = data.map((img) => ({
          id: img.src, 
          src: img.src,
          alt: img.alt || "Gallery Image",
          orientation: "loading", 
        }));
        setImages(loadedImages);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error loading images:", err);
        setError("Could not load gallery. Please check that list_images.php is uploaded correctly.");
        setIsLoading(false);
      });
  }, []);

  const onImageLoad = (e, id) => {
    const img = e.target;
    const aspectRatio = img.naturalWidth / img.naturalHeight;
    const orientation = aspectRatio > 1.2 ? 'landscape' : 'portrait';

    setImages((prevImages) => 
      prevImages.map((imgItem) => 
        imgItem.id === id ? { ...imgItem, orientation } : imgItem
      )
    );
  };

  const openModal = (index) => {
    setSelectedImageIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImageIndex(null);
    document.body.style.overflow = 'unset';
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const showNext = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImageIndex === null) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') showNext(e);
      if (e.key === 'ArrowLeft') showPrev(e);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImageIndex]);

  return (
    <div className="page-container">
      <Header />

      <main className="gallery-content"> 
        {isLoading && <div className="loading-text">Loading Gallery...</div>}
        {error && <div className="error-text">{error}</div>}
        {!isLoading && !error && images.length === 0 && (
          <div className="empty-state">
            <p>No images found in the 'gallery-uploads' folder.</p>
          </div>
        )}       
        <div className="gallery-grid">
          {images.map((img, index) => (
            <div 
              key={img.id} 
              className={`gallery-item ${img.orientation}`}
              onClick={() => openModal(index)}
            >
              <img 
                src={img.src} 
                alt={img.alt} 
                loading="lazy"
                onLoad={(e) => onImageLoad(e, img.id)}
              />
              <div className="overlay">
                <span>View</span>
              </div>
            </div>
          ))}
        </div>
      </main>

      {selectedImageIndex !== null && images[selectedImageIndex] && (
        <div className="lightbox" onClick={closeModal}>
          <button className="close-btn" onClick={closeModal}>✕</button>
          
          <button className="nav-btn prev" onClick={showPrev}>&#10094;</button>
          
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={images[selectedImageIndex].src} 
              alt={images[selectedImageIndex].alt} 
            />
          </div>

          <button className="nav-btn next" onClick={showNext}>&#10095;</button>
        </div>
      )}
    </div>
  );
};

export default Gallery;